// extracted by mini-css-extract-plugin
export default {"title":"BIyIRq","testimonials":"GDSGp5","quote":"YvN0_7","nameMobile":"dMnnuQ","photo":"mfTumr","fullHeight":"pesu3H","testimonialsContainer":"GfFq4z","slideShow":"t5zbwS"};